import { render, staticRenderFns } from "./MatchSideSelection.vue?vue&type=template&id=e310cd76&scoped=true&"
import script from "./MatchSideSelection.vue?vue&type=script&lang=js&"
export * from "./MatchSideSelection.vue?vue&type=script&lang=js&"
import style0 from "./MatchSideSelection.vue?vue&type=style&index=0&id=e310cd76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e310cd76",
  null
  
)

export default component.exports